import React from 'react';
import { wrapFunctionalComponent } from 'utils/framework';
import { Text, Box, Button } from 'components/ui';
import { colors } from 'style/config';
import Checkbox from 'components/Inputs/Checkbox/Checkbox';
import agentAwareUtils from 'utils/AgentAware';
import localeUtils from 'utils/LanguageLocale';
import GetItShippedShippingGroups from 'components/FrictionlessCheckout/ShippingMethods/GetItShippedShippingGroups';
import AutoReplenishShippingGroups from 'components/FrictionlessCheckout/ShippingMethods/AutoReplenishShippingGroups';

const STANDARD = !localeUtils.isCanada() ? 'Standard' : localeUtils.isFrench() ? 'standard' : 'Free';

function ShippingMethodItems(props) {
    const {
        isReplenOnly,
        locales,
        orderHasReplen,
        shippingMethod,
        deliveryGroups,
        standardItemsQuantity,
        replenishItemsQuantity,
        isPhysicalGiftCard,
        isElectronicShippingGroup,
        isEditView,
        showAutoReplenishModal,
        openAutoReplenishProductsModal,
        standardBasket,
        message,
        handleCheckboxChange,
        setShippingMethod
    } = props;

    const shouldShowExpeditedText = !shippingMethod?.shippingMethodType.includes(STANDARD) && orderHasReplen;

    return (
        <Box
            backgroundColor={colors.nearWhite}
            paddingTop={2}
            paddingX={4}
        >
            {Sephora.isAgent && !orderHasReplen && agentAwareUtils.isAgentAwareSession() && (
                <Checkbox
                    marginBottom={3}
                    marginTop={5}
                    fontWeight='bold'
                    checked={message}
                    data-at={Sephora.debug.dataAt('work_at_seph_checkbox')}
                    onClick={handleCheckboxChange}
                >
                    {locales.waiveShippingHandling}
                </Checkbox>
            )}
            {!isReplenOnly && standardBasket?.items?.length > 0 && (
                <GetItShippedShippingGroups
                    locales={locales}
                    standardItemsQuantity={standardItemsQuantity}
                    isPhysicalGiftCard={isPhysicalGiftCard}
                    isElectronicShippingGroup={isElectronicShippingGroup}
                    shippingMethod={shippingMethod}
                    deliveryGroups={deliveryGroups}
                />
            )}

            {orderHasReplen && (
                <Box marginTop={isReplenOnly ? 0 : 2}>
                    <AutoReplenishShippingGroups
                        locales={locales}
                        replenishItemsQuantity={replenishItemsQuantity}
                        isPhysicalGiftCard={isPhysicalGiftCard}
                        isReplenOnly={isReplenOnly}
                        shippingMethod={shippingMethod}
                        deliveryGroups={deliveryGroups}
                        isEditView={isEditView}
                        showAutoReplenishModal={showAutoReplenishModal}
                        openAutoReplenishProductsModal={openAutoReplenishProductsModal}
                    />
                </Box>
            )}
            <Button
                variant='primary'
                onClick={setShippingMethod}
                children={locales.chooseThisShippingSpeed}
                marginTop={[4, 4, 5]}
                marginBottom={[shouldShowExpeditedText ? 2 : 3, shouldShowExpeditedText ? 2 : 3, 4]}
            />
            {shouldShowExpeditedText && (
                <Text
                    fontSize='sm'
                    lineHeight='14px'
                    pb={3}
                    is='p'
                    children={locales.expeditedText}
                />
            )}
        </Box>
    );
}

export default wrapFunctionalComponent(ShippingMethodItems, 'ShippingMethodItems');
